// Bidder-web observability barrel (GT1-414). The structured logger,
// correlation plumbing, redaction allowlist, and error capture now live in
// @neon-one/frontend-observability so admin-web and bidder-web share one
// source of truth. This barrel wires the shared package with bidder-web's
// source name, its env-driven log level, and its /client-errors beacon.
import { createErrorHandlers, createLogger } from '@neon-one/frontend-observability';

import { env } from '@/shell/env';

import { reportError } from '../error-boundary/reportError';

const { logger, registerSink, resetSinks } = createLogger({
    source: 'bidder-web',
    getLogLevel: () => env.logLevel,
});

const { installGlobalErrorHandlers } = createErrorHandlers({ logger, reportError });

export { logger, registerSink, resetSinks, installGlobalErrorHandlers };
export {
    CORRELATION_ID_HEADER,
    attachCorrelationId,
    consoleSink,
    getSessionId,
    newRequestId,
    redactSensitive,
    redactString,
    LOG_LEVELS,
} from '@neon-one/frontend-observability';
export type { Logger, LogLevel, LogEntry, LogSink } from '@neon-one/frontend-observability';
